import { useState } from "react";
import Select from "react-select";
import CloseIcon from "@mui/icons-material/Close";
import { NestedSelect } from "./CustomSelect";
import { transformICDRecursive } from "../lib/utils";

export default function ReviewPageDropdown({
  text,
  lists,
  setCodes,
  codes,
  placeHolder,
  isNested,
}) {
  const [selectedList, setSelectedList] = useState(null);
  const handleAdd = () => {
    if (!selectedList) return;
    console.log(selectedList);
    const isCodeAlreadyAdded = codes.some(
      (item) => item.id === selectedList.id
    );
    if (isCodeAlreadyAdded) {
      return;
    }
    setCodes((prev) => [...prev, selectedList]);
    setSelectedList(null);
  };

  const handleRemove = (id) => {
    setCodes((prev) => prev.filter((item) => item.id !== id));
  };

  // this needs to be changed later

  const options = isNested
    ? transformICDRecursive(lists || {})
    : Array.isArray(lists)
    ? lists.map((item) => ({
        label: `${item?.icd_code || item?.code} - ${item?.description}`,
        value: item?.id,
      }))
    : [];

  return (
    <div>
      <div className="flex items-start w-full">
        <div className="bg-[#015A52] text-white p-2 text-base sm:text-xl rounded-xl h-fit w-fit text-nowrap mr-2">
          {text}
        </div>
        <div className="flex flex-col w-full space-y-2">
          {codes?.map((item, index) => (
            <div
              key={index}
              className="group bg-[#F1F1F1] p-2 rounded-lg flex items-center justify-between w-full hover:bg-[#ddd] transition-colors duration-200 h-12"
            >
              <span>
                {item?.icd_code || item?.code} - {item?.description}
              </span>
              <div className="hidden group-hover:block duration-200">
                <CloseIcon
                  onClick={() => handleRemove(item.id)}
                  className="text-white bg-custom-green rounded-full cursor-pointer ml-2 p-1 hidden group-hover:block duration-200"
                  fontSize="large"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex gap-3 flex-wrap">
        <div className="w-full flex items-center space-x-2 mt-2">
          {isNested ? (
            <NestedSelect
              options={options}
              value={selectedList?.id}
              onChange={(val) => {
                let selectedItem;
                if (isNested) {
                  console.log(val);
                  selectedItem = {
                    id: val.id,
                    code: val.id,
                    description: val.description,
                  };
                } else {
                  selectedItem = lists.find((item) => item?.id === val.id);
                }
                setSelectedList(selectedItem);
              }}
              placeholder={placeHolder}
              className="w-full text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#015A52] focus:border-[#015A52]"
            />
          ) : (
            <Select
              options={options}
              value={
                selectedList
                  ? {
                      label: `${selectedList.icd_code || selectedList.code} - ${
                        selectedList.description
                      }`,
                      value: selectedList.id,
                    }
                  : null
              }
              // need to change this according to nested
              onChange={(selectedOption) => {
                const selectedItem = lists.find(
                  (item) => item?.id === selectedOption.value
                );
                setSelectedList(selectedItem);
              }}
              placeholder={placeHolder}
              className="w-full text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#015A52] focus:border-[#015A52]"
            />
          )}
          {/* <CustomSelect
            optionsList={options}
            value={selectedList}
            lists={lists}
            onChange={(selected) => setSelectedList(selected)}
            placeholder="Select ICD Code"
          /> */}

          <button
            onClick={handleAdd}
            className="w-11 h-11 flex items-center justify-center rounded-full text-xl p-2 bg-[#015A52] text-white"
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
}
